/**
 * 메트로놈 클릭 (2026-10, 새 디자인). 예전 wav 를 따로 도는 타이머로 틀던 방식은 악보와 점점 어긋나서,
 * 악보가 한 칸(박) 나아갈 때마다 바로 소리를 만든다. 마디 첫 박은 높고 크게(강세).
 */
let ctx: AudioContext | null = null;

const getCtx = () => {
  if (!ctx) {
    const Ctx = (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return null;
    ctx = new Ctx();
  }
  return ctx;
};

// 휴대폰은 터치한 순간에만 소리를 허용하므로 버튼을 누를 때 불러 둔다
export const prepareMetronome = () => {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
};

export const click = (accent: boolean) => {
  const c = getCtx();
  if (!c) return;
  const t = c.currentTime + 0.005;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = "square";
  osc.frequency.value = accent ? 1760 : 1175;
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(accent ? 0.5 : 0.25, t + 0.002);
  gain.gain.exponentialRampToValueAtTime(0.0001, t + (accent ? 0.06 : 0.04));
  osc.connect(gain).connect(c.destination);
  osc.start(t);
  osc.stop(t + 0.08);
};

/** 탭 템포: 최근 탭 간격의 평균으로 BPM 계산 (2초 넘게 쉬면 새로 시작) */
let taps: number[] = [];
export const tapTempo = (): number | null => {
  const now = performance.now();
  if (taps.length && now - taps[taps.length - 1] > 2000) taps = [];
  taps.push(now);
  if (taps.length > 6) taps.shift();
  if (taps.length < 3) return null;
  const gaps = taps.slice(1).map((v, i) => v - taps[i]);
  const avg = gaps.reduce((a, b) => a + b, 0) / gaps.length;
  return 60000 / avg;
};
